/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, type HttpValidationProblemDetails, type IError } from '../../models/index.js';
// @ts-ignore
import { ReadRequestBuilderRequestsMetadata, type ReadRequestBuilder } from './read/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /notifications/{id}
 */
export interface NotificationsItemRequestBuilder extends BaseRequestBuilder<NotificationsItemRequestBuilder> {
    /**
     * The read property
     */
    get read(): ReadRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     delete(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const NotificationsItemRequestBuilderUriTemplate = "{+baseurl}/notifications/{id}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const NotificationsItemRequestBuilderNavigationMetadata: Record<Exclude<keyof NotificationsItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    read: {
        requestsMetadata: ReadRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const NotificationsItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: NotificationsItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, application/problem+json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
    },
};
/* tslint:enable */
/* eslint-enable */
